import { FC } from 'react';

import { CreditCard } from '__generated__/GQL';
import SunshineTag from 'components/_core/SunshineTag';
import { useFakeTemporaryVirtualPaymentCardIdContext } from 'features/PaymentCards/context';

import locales from './locales';
import {
  getPaymentCardStatusBadgeColor,
  getPaymentCardStatusBadgeLabel,
} from './utils';

interface PaymentCardStatusBadgeProps {
  creditCard: CreditCard;
}

const PaymentCardStatusBadge: FC<PaymentCardStatusBadgeProps> = ({
  creditCard,
}) => {
  const badgeLabel = getPaymentCardStatusBadgeLabel(creditCard);
  const badgeColorScheme = getPaymentCardStatusBadgeColor(creditCard);

  const fakeTemporaryVirtualPaymentCardId =
    useFakeTemporaryVirtualPaymentCardIdContext();
  const isFakeTemporaryVirtualCard =
    creditCard.creditCardId === fakeTemporaryVirtualPaymentCardId;
  return (
    <>
      {isFakeTemporaryVirtualCard ? (
        <SunshineTag colorScheme="blue" flexShrink={0} size="sm">
          {locales.pendingAutomaticVirtualCard}
        </SunshineTag>
      ) : (
        <SunshineTag colorScheme={badgeColorScheme} size="sm">
          {badgeLabel}
        </SunshineTag>
      )}
    </>
  );
};

export default PaymentCardStatusBadge;
